<template>
  <div class="template">
    <ServicesDesktop class="template__Desktop"/>
    <ServicesMobile class="template__Mobile"/>
  </div>
</template>

<script>
import ServicesMobile from '@/components/services/ServicesMobile.vue'
import ServicesDesktop from '@/components/services/ServicesDesktop.vue'
export default {
  name: 'ServicesView',
  components: {
    ServicesDesktop,
    ServicesMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>